import { css } from "emotion";
import React, { Component } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import getYear from "date-fns/get_year";
import { noop } from "../../utils";

const yearPickerContainer = css`
  margin: 0.5rem;
  display: flex;
  justify-content: center;
  & select {
    padding: 5px;
    width: 100%;
    text-align: center;
  }
`;

const CustomYearHeader = ({ date, changeYear }) => {
  const years = [];
  const currentDate = new window.Date();
  const currentYear = currentDate.getFullYear();
  for (let i = currentYear; i >= 1990; i--) {
    years.push(i);
  }

  return (
    <div className={yearPickerContainer}>
      <select
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(value)}
        aria-label="Year"
      >
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

class Date extends Component {
  render() {
    const {
      dateFormat,
      calendarClassName,
      dayClassName,
      popperPlacement,
      showMonthYearPicker,
      selected,
      handleDatePick,
      id,
      name,
    } = this.props;
    const monthyearViewClassNames = showMonthYearPicker
      ? "monthyear__view"
      : "";

    const pickerProps = {};

    if (showMonthYearPicker) {
      pickerProps.showMonthYearPicker = true;
      pickerProps.renderCustomHeader = CustomYearHeader;
    } else {
      pickerProps.showDay = true;
      pickerProps.dropdownMode = "select";
      pickerProps.showYearDropdown = true;
      pickerProps.showMonthDropdown = true;
    }

    return (
      <DatePicker
        id={id}
        name={name}
        dateFormat={dateFormat}
        selected={selected}
        onChange={handleDatePick}
        className="date"
        calendarClassName={`${monthyearViewClassNames} ${calendarClassName}`}
        dayClassName={dayClassName}
        popperPlacement={popperPlacement}
        {...pickerProps}
      />
    );
  }
}

Date.displayName = "DatePicker";

Date.propTypes = {
  dateFormat: PropTypes.string,
  className: PropTypes.string,
  dayClassName: PropTypes.string,
  calendarClassName: PropTypes.string,
  handleDatePick: PropTypes.func,
  popperPlacement: PropTypes.any,
  selected: PropTypes.any,
  showMonthYearPicker: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
};

Date.defaultProps = {
  dateFormat: "MM/dd/yyyy",
  className: "",
  dayClassName: "",
  calendarClassName: "",
  handleDatePick: noop,
  showMonthYearPicker: false,
  id: undefined,
  name: undefined,
};

export default Date;
